import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";
import { TiInfoOutline } from "react-icons/ti";
import NoRecord from "app/Components/CommanComponents/NoRecord";

class BasicBarChartWithCustomToolTip extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.seriesData !== this.props.seriesData) {
      // console.log("forceUpdate");
      this.forceUpdate();
    }
  }

  render() {
    let {
      category,
      seriesData,
      xAxis,
      yAxis,
      xAxisName,
      yAxisName,
      customToolTip,
      legendFlag,
    } = this.props;

    // console.log("seriesData", seriesData);
    let echartMultipleBar2Option = {
      tooltip: {
        formatter: (params) => {
          // console.log("BasicBarChartWithCustomToolTip", customToolTip[params?.name][0]?.fullName, customToolTip, params);
          return `${params?.marker}${"&nbsp"}${
            customToolTip[params?.name][0]?.fullName
          } : ${params?.value}<br/>`;
        },
      },
      yAxis: yAxis
        ? yAxis
        : {
            name: yAxisName ? yAxisName : "",
            nameLocation: "end",
            type: "value",
            min: 0, // minimum value to start
            minInterval: 1, // for integer axis value
            nameTextStyle: {
              fontWeight: "bold",
            },
          },
      xAxis: xAxis
        ? {
            ...xAxis,
            nameTextStyle: {
              color: "white",
            },
          }
        : {
            name: xAxisName ? xAxisName : "",
            nameLocation: "end",
            nameRotate: 90,
            nameTextStyle: {
              fontWeight: "bold",
              color: "white",
            },
            type: "category",
            data: category ? category : [],
          },
      legend:
        legendFlag == false
          ? false
          : {
              type: "scroll",
              // horizontalAlign: 'center',
              itemGap: 20,
              to: 100,
            },
      series: seriesData ? seriesData : [],
      dataZoom: [
        {
          start: 0,
          type: "inside",
        },
        {
          start: 0,
        },
      ],
    };

    if (this.props.isLegeng) {
      echartMultipleBar2Option.legend = this.props.isLegeng;
    }
    if (this.props.grid) {
      echartMultipleBar2Option.grid = this.props.grid;
    }
    let name =
      echartMultipleBar2Option.xAxis &&
      Object.keys(echartMultipleBar2Option.xAxis).length > 0 &&
      echartMultipleBar2Option.xAxis.name
        ? echartMultipleBar2Option.xAxis.name
        : null;

    // echartMultipleBar2Option = JSON.parse(JSON.stringify(echartMultipleBar2Option));
    // console.log("echartMultipleBar2Option", echartMultipleBar2Option);
    return (
      <React.Fragment>
        {
          Array.isArray(seriesData) && seriesData.length > 0 ? (
            <>
              <ReactEcharts
                style={{ height: this.props.height ? this.props.height : "306px" }}
                option={echartMultipleBar2Option}
              />
              <div className="text-center" style={{ marginTop: -30 }}>
                <span
                  className="font-weight-bold"
                  style={{ textTransform: "capitalize" }}
                >
                  {name}
                </span>
              </div>
            </>
          ) : (
            <NoRecord />
          )
          // <div className="noRecordFound"><TiInfoOutline /> No Records found...!</div>
        }
      </React.Fragment>
    );
  }
}

export default BasicBarChartWithCustomToolTip;
